import switchFunc from 'lib/function/switchFunc'
import LineAwardIcon from 'LuxKit/Icons/line/LineAwardIcon'
import LineBanIcon from 'LuxKit/Icons/line/LineBanIcon'
import LineBedDoubleIcon from 'LuxKit/Icons/line/LineBedDoubleIcon'
import LineBedIcon from 'LuxKit/Icons/line/LineBedIcon'
import LineBusIcon from 'LuxKit/Icons/line/LineBusIcon'
import LineCalendarIcon from 'LuxKit/Icons/line/LineCalendarIcon'
import LineDollarSignAltIcon from 'LuxKit/Icons/line/LineDollarSignAltIcon'
import LineFileCheckAltIcon from 'LuxKit/Icons/line/LineFileCheckAltIcon'
import LineFileMinusAltIcon from 'LuxKit/Icons/line/LineFileMinusAltIcon'
import LineFilePlusAltIcon from 'LuxKit/Icons/line/LineFilePlusAltIcon'
import LineHeartPlusIcon from 'LuxKit/Icons/line/LineHeartPlusIcon'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import LineLocationPinAltIcon from 'LuxKit/Icons/line/LineLocationPinAltIcon'
import LineLuggageIcon from 'LuxKit/Icons/line/LineLuggageIcon'
import LinePlaneDepartureIcon from 'LuxKit/Icons/line/LinePlaneDepartureIcon'
import LinePlusCircleIcon from 'LuxKit/Icons/line/LinePlusCircleIcon'
import LineRestaurantIcon from 'LuxKit/Icons/line/LineRestaurantIcon'
import LineShieldCheckIcon from 'LuxKit/Icons/line/LineShieldCheckIcon'
import LineSyringeIcon from 'LuxKit/Icons/line/LineSyringeIcon'
import LineTicketIcon from 'LuxKit/Icons/line/LineTicketIcon'
import LineUsersAltIcon from 'LuxKit/Icons/line/LineUsersAltIcon'

const TOUR_V2_FINE_PRINT_CATEGORY_ICONS: Record<App.Tours.V2OfferFinePrintSection['title'], (props: any) => React.ReactElement> = {
  accommodation: LineBedDoubleIcon,
  booking: LineTicketIcon,
  cancellations: LineBanIcon,
  dates: LineCalendarIcon,
  exclusions: LineFileMinusAltIcon,
  food: LineRestaurantIcon,
  health: LineHeartPlusIcon,
  inclusions: LineFilePlusAltIcon,
  information: LineInfoCircleIcon,
  surcharges: LineDollarSignAltIcon,
  transport: LineBusIcon,
  travel: LinePlaneDepartureIcon,
  vaccination: LineSyringeIcon,
  destination: LineLocationPinAltIcon,
  baggage_restrictions: LineLuggageIcon,
  optional_extras: LinePlusCircleIcon,
}

export const getFinePrintSectionIcon = switchFunc(TOUR_V2_FINE_PRINT_CATEGORY_ICONS, LineInfoCircleIcon)

const TOUR_V2_FAQ_ITEM_ICONS: Record<string, (props: any) => React.ReactElement> = {
  'The operator': LineAwardIcon,
  'The accommodation': LineBedIcon,
  'The experience': LineFileCheckAltIcon,
  'The service': LineShieldCheckIcon,
  'The group': LineUsersAltIcon,
}

export const getFAQItemIcon = switchFunc(TOUR_V2_FAQ_ITEM_ICONS, LineInfoCircleIcon)
